export const NAME = 'name';
export const JOB_TITLES = 'jobTitles';
export const REQUEST_SKILL_STATUS = 'requestSkillStatus';

export const STATUS_ACCEPTED = 'ACCEPT';
